import { useState,useEffect } from "react";
import DataTable from "react-data-table-component";
import { customStyles } from "../../utils/data/essential";
import { useFetchData } from "../../hooks/useFetchData";
import { CSVLink } from "react-csv";
import { reconciliationColumns, reconciliationHeaders } from "../../utils/columns/reconciliation";
import moment from "moment";
const Reconciliation = () => {
  const [reconData, setReconData] = useState([])
  const [exportData, setexportData] = useState([])
  const user = JSON.parse(localStorage.getItem("user"));
  let columns = [];
  // Fetch reconciliation data
  const url = `operators/100001/reconciliations`;
  const { data, isLoading } = useFetchData(["reconciliation"], url, true, user);
  if (data) {
    columns = reconciliationColumns(data);
  }
  useEffect(() => {
    extractDataToExport(data);
    setReconData(data?.reverse());
  }, [data])
  const extractDataToExport = (data) => {
    let obj = {};
    let arr = [];
    data?.forEach((el) => {
      obj.operator = "Galaxy Group";
      obj.status = el.status.name;
      obj.reconciliationPeriod = el.reconciliationPeriod;
      obj.totalCollectionAmount = el.totalCollectionAmount;
      obj.totalCommissionAmount = el.totalCommissionAmount;
      obj.totalDisbursementAmount = el.totalDisbursementAmount;
      obj.totalTransferedAmount = el.totalTransferedAmount;
      obj.totalRefundedAmount = el.totalRefundedAmount;
      obj.momoCollectionFeeAmount = el.momoCollectionFeeAmount;
      obj.totalTobepaidAmount = el.totalTobepaidAmount;
      obj.totalPaidAmount = el.totalPaidAmount;
      obj.transferId = el.transferId;
      obj.transferScheduledDate = moment(el.transferScheduledDate).format(
        "DD-MM-YYYY H:mm:ss A"
      );
      arr.push(obj);
      obj = {};
    });
    setexportData(arr);
  };
  if (isLoading)
    return (
      <div
        className='d-flex justify-content-center'
        style={{ marginTop: "15%" }}
      >
        <h5>Loading...</h5>
      </div>
    );
  return (
    <div>
      <div className='d-flex justify-content-center mt-3'>
        <h3>Reconciliation</h3>
      </div>
      {reconData?.length > 0 && (
        <div className='d-flex justify-content-end mr-3'>
          <CSVLink
            data={exportData}
            headers={reconciliationHeaders}
            filename={`reconciliations`}
          >
            <button
              type='button'
              className='btn btn-primary housesTableFilterBtn'
              disabled={data?.length === 0}
              style={{
                backgroundColor: data?.length === 0 ? "#cbcbcb" : "#124db1",
                color: data?.length === 0 ? "#000" : "",
                cursor: data?.length === 0 ? "default" : "pointer",
              }}
            >
              Excel{" "}
              <i
                style={{ marginLeft: "1rem" }}
                className='fas fa-file-excel'
              ></i>
            </button>
          </CSVLink>
        </div>
      )}
      <div
        className='table-responsive datatables dataValidation-Wrap'
        style={{ width: "100%" }}
      >
        <DataTable
          columns={columns}
          data={reconData}
          defaultSortField='date'
          defaultSortAsc={false}
          responsive={true}
          customStyles={customStyles}
          pagination
          highlightOnHover
          numberiped
          noHeader
        />
      </div>
    </div>
  );
};
export default Reconciliation;
